<script lang="ts">
    import { ConfigurationManager } from "../../ConfigurationManager";
    import { type IGamesController } from "../../controller/IGamesController";
    import { Game } from "../../model/Game";
    import { getAuthInfo, type AuthInfo } from "../../utility/AccountUtility";
    import AuthGuard from "../../utility/AuthGuard.svelte";
    import AddCard from "../components/AddCard.svelte";
    import BootstrapVectorIcon from "../components/BootstrapVectorIcon.svelte";
    import GameInfoCard from "../fragments/GameInfoCard.svelte";
    import SlotInfoCard from "../fragments/SlotInfoCard.svelte";

    let { params = { id: undefined } } = $props();

    let gamesController: IGamesController =
        ConfigurationManager.getInstance().gamesController;

    let game: Game = $state(undefined);

    gamesController.getGame(params.id).then((val: Game) => {
        game = val;
    });

    let auth: AuthInfo = getAuthInfo();

    // @TODO add twitch stream count and twitch stream viewer count to make a slot more valuable
    // @TODO add game player count stats
</script>

<h1 class="h2">Game Details</h1>

{#if game}
    <div class="row d-flex">
        <GameInfoCard {game} horizontal={true}  showKeys={true} class="d-flex"></GameInfoCard>
    </div>
    <div class="row d-flex">
        <h2 class="my-4">Advertising Spaces</h2>
        {#each game.slots as slot}
            <SlotInfoCard {slot} showBookingButton={auth.isAdvertiser()} showLinkToPromptEngineering={game && game.isOwner(auth)} showLinkToStats={game && game.isOwner(auth)} showLinkToCopySlot={game && game.isOwner(auth)} class="col-12 col-lg-3 px-2 mb-4"
            ></SlotInfoCard>
        {/each}
        <AuthGuard game={game}>
            <div  class="col-12 col-lg-3 px-2 mb-4">
                <AddCard link={"#/game/" + game.id+ "/slot"}></AddCard>
            </div>
        </AuthGuard>
    </div>
{:else}
    Loading
{/if}
